import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import EditIcon from '@mui/icons-material/Edit'
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Collapse from '@mui/material/Collapse'
import { red } from '@mui/material/colors'

import { PropertyRow } from '../../../theme/components/PropertyRow'
import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import { stringToColor } from '../../../theme/util/color-util'
import type { Contactpersoon } from '../types/Contactpersoon'

export { ContactpersoonCard }

type Props = {
  contactpersoon: Contactpersoon
  onOpenLog: () => void
  onEdit: () => void
  onDelete: () => void
  expanded: boolean
}

const ContactpersoonCard = ({
  contactpersoon,
  onOpenLog,
  onEdit,
  onDelete,
  expanded,
}: Props) => {
  const { status, rol, naam, telefoonnummer, emailadres, contactOrganisatie } =
    contactpersoon

  const isDeleted = status === 'cancelled'

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      <CardHeader
        avatar={
          <Avatar
            // eslint-disable-next-line no-magic-numbers
            sx={{ bgcolor: isDeleted ? red[500] : stringToColor(naam) }}
            aria-label="recipe"
          >
            {naam.charAt(0).toUpperCase()}
          </Avatar>
        }
        title={naam}
        subheader={
          isDeleted
            ? 'Verwijderd'
            : `${rol}${contactOrganisatie ? ` bij ${contactOrganisatie}` : ''}`
        }
        action={isDeleted && <DoDisturbIcon color="error" />}
      />

      <Collapse in={expanded} unmountOnExit>
        <Box>
          <CardContent
            sx={{ gap: 2, display: 'flex', flexDirection: 'column' }}
          >
            <PropertyRow label="Telefoon" value={telefoonnummer} />

            <PropertyRow
              label="Email"
              value={emailadres}
              copy={isDeleted ? undefined : emailadres}
            />
          </CardContent>

          <CardActions disableSpacing>
            <Box sx={{ display: 'flex', gap: 1, flexGrow: 1 }}>
              {!isDeleted && (
                <StyledIconButton
                  title="Verwijderen"
                  onClick={onDelete}
                  icon={<DeleteOutlineIcon />}
                />
              )}
            </Box>

            <Box>
              {!isDeleted && (
                <StyledIconButton
                  title="Bewerken"
                  onClick={onEdit}
                  icon={<EditIcon />}
                />
              )}

              <StyledIconButton
                title="Log bekijken"
                onClick={onOpenLog}
                icon={<InfoOutlineIcon />}
              />
            </Box>
          </CardActions>
        </Box>
      </Collapse>
    </Card>
  )
}
